/**
 * Keys that represents a Building's attributes, shared between {@link BuildingAttributes}
 * and {@link SpaceConditions}
 */
var BuildingAttrKeys;
(function (BuildingAttrKeys) {
    BuildingAttrKeys["Units"] = "Units";
    BuildingAttrKeys["Ffl"] = "Ffl";
    BuildingAttrKeys["Levels"] = "Levels";
    BuildingAttrKeys["LevelHeight"] = "LevelHeight";
    BuildingAttrKeys["PodiumHeight"] = "PodiumHeight";
    BuildingAttrKeys["MaxModuleDepth"] = "MaxModuleDepth";
    BuildingAttrKeys["FloorArea"] = "FloorArea";
    BuildingAttrKeys["Generator"] = "Generator";
    BuildingAttrKeys["Sprinklered"] = "Sprinklered";
    BuildingAttrKeys["DistrictHeating"] = "DistrictHeating";
    BuildingAttrKeys["EnergyCentre"] = "EnergyCentre";
    BuildingAttrKeys["PassengerLifts"] = "PassengerLifts";
    BuildingAttrKeys["FirefightingLifts"] = "FirefightingLifts";
    BuildingAttrKeys["CentralASHP"] = "CentralASHP";
    BuildingAttrKeys["City"] = "City";
    BuildingAttrKeys["UnitsStudio"] = "UnitsStudio";
    BuildingAttrKeys["Units1B1P"] = "Units1B1P";
    BuildingAttrKeys["Units1B2P"] = "Units1B2P";
    BuildingAttrKeys["Units2B"] = "Units2B";
    BuildingAttrKeys["CoreShafts"] = "CoreShafts";
})(BuildingAttrKeys || (BuildingAttrKeys = {}));

export { BuildingAttrKeys };
//# sourceMappingURL=building-attr-keys.js.map
